import BaseTheme from '../base';

export default {
  ...BaseTheme.FontWeights
};
